import * as React from "react";
import Tag from "../../../../generic/tag";
import { FTChipColorKeyComb, FTScrollStyle } from "../../ftConstants";
import EdButton from "../../../../generic/edButton";
import { AFTVerifyPayin } from "../../../../service/fundTransfer/fundTransferApiService";
import moment from "moment";
import dateTimeFormat from "../../../../service/dateTimeService";
import { toINR } from "../../../../service/numberFormat";

export interface IFtHistoryTblPayInDeskProps {
  data: Array<any>;
}

const FtHistoryTblPayInDesk: React.FC<IFtHistoryTblPayInDeskProps> = (
  props
) => {
  // isAccordianOpen = if row is open then it stores rowIndex otherwise -1
  const [isAccordianOpen, setIsAccordianOpen] = React.useState<number>();

  // used to open/close tab
  function toggleTab(index: number) {
    if (isAccordianOpen === index) {
      setIsAccordianOpen(undefined);
    } else {
      setIsAccordianOpen(index);
    }
  }
  function verifyRes(res: any) {
    //console.log(res);
  }

  const PayInVerify = (instNo: string) => {
    AFTVerifyPayin(verifyRes, { instNo });
  };

  return (
    <div className="ft_hist_table">
      <ul
        className={
          "ft_his_data " + (props.data.length > 0 ? "ftScrollCont" : "")
        }
        style={FTScrollStyle(props.data.length > 0 ? true : false)}
      >
        {props.data.map((row, index) => {
          return (
            <li
              onClick={() => toggleTab(index)}
              className={
                "ft_his_row" + (isAccordianOpen === index ? " active" : "")
              }
              key={index}
            >
              <div className="fl_his fl_his_in">
                <div className="col date_time">
                  <label className="tm">
                    {moment(row.tm, ["h:mm A"]).format("HH:mm:ss")}{" "}
                  </label>
                  <label>
                    {" "}
                    {moment(dateTimeFormat(row.dt, " ")).format("DD MMM 'YYYY")}
                  </label>
                </div>
                <div className="col bank">{row.bnkName}</div>
                <div className="col amount">₹{toINR(row.trnsAmt)}</div>
                <div className="col status">
                  <Tag
                    value={row.sts}
                    shape="chip"
                    color={FTChipColorKeyComb[row.sts.toLowerCase()]}
                  />
                </div>
              </div>
              <div className="panel_txt">
                <div className="panel_data">
                  <label className="txt">Bank A/C</label>
                  <label className="val">{row.bnkAccNo}</label>
                </div>
                <div className="panel_data">
                  <label className="txt">Mode</label>
                  <label className="val">{row.payMd}</label>
                </div>
                {row.payMd === "UPI" && (
                  <div className="panel_data">
                    <label className="txt">UPI ID</label>
                    <label className="val">{row.upi}</label>
                  </div>
                )}
                {row.ldgrNm && (
                  <div className="panel_data">
                    <label className="txt">Ledger</label>
                    <label className="val">{row.ldgrNm}</label>
                  </div>
                )}
                <div className="panel_data">
                  <label className="txt">Ref No.</label>
                  <label className="val">{row.instNo}</label>
                </div>
                {row.sts.toLowerCase() === "failed" && (
                  <>
                    <div className="panel_data">
                      <label className="txt">Reason</label>
                      <label
                        className={
                          "val " +
                          (row.sts.toLowerCase() === "failed" ? "red" : "")
                        }
                      >
                        {row.rmk}
                      </label>
                      {row.verify === "true" && (
                        <EdButton
                          value="Verify Status"
                          btnTyp="link"
                          className="showDetls refsh_btn"
                          onClick={() => PayInVerify(row.instNo)}
                        />
                      )}
                    </div>
                  </>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default FtHistoryTblPayInDesk;
